import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides outdoor services near me in Daytona Beach, Ormond Beach, and Palm Coast, FL?',
    a: "Dippel's Outdoor Services provides professional fencing, pavers, landscape installation, outdoor lighting, and custom sheds throughout Daytona Beach, Ormond Beach, Port Orange, New Smyrna Beach, Edgewater, and Palm Coast. Call (386) 301-4399 to schedule a free estimate anywhere in Volusia or Flagler County.",
  },
  {
    q: 'How much do outdoor projects cost in Volusia County, Florida?',
    a: "Project costs vary based on scope, materials, and property size. Fencing, paver patios, landscape installations, and custom sheds each have different price points. Dippel's provides free, itemized estimates with transparent pricing and no hidden fees — call (386) 301-4399 or submit our consultation request form to get your accurate quote.",
  },
  {
    q: 'How long does outdoor installation take from start to finish?',
    a: "Most projects are completed in 1–5 days depending on scale. Fence installations typically take 1–2 days; paver patios and driveways 2–5 days; landscape installations 1–3 days. We provide a clear, confirmed timeline in your proposal so you always know exactly when your project will be done.",
  },
  {
    q: 'What types of fences does Dippel\'s Outdoor Services install?',
    a: "Dippel's installs vinyl fences, wood fences, chain link fences, and aluminum fences across Florida's east coast. Each type is available in multiple styles, heights, and colors to match your property's aesthetic and meet Florida HOA requirements.",
  },
  {
    q: 'Do you offer landscape lighting and irrigation systems in Florida?',
    a: "Yes. Dippel's designs and installs full outdoor lighting systems — path lights, accent uplighting, deck and step lighting — plus smart sprinkler and drip irrigation systems engineered for Florida's unique climate and water conservation needs.",
  },
  {
    q: 'Can Dippel\'s build a custom shed for my Florida property?',
    a: "Absolutely. We build storage sheds, garden sheds, workshop sheds, utility sheds, and metal sheds — all built to Florida code and designed to complement your property's existing aesthetic while standing up to Florida weather year-round.",
  },
  {
    q: 'Do you serve Palm Coast and Flagler County?',
    a: "Yes. Dippel's Outdoor Services proudly serves Palm Coast and greater Flagler County alongside our Volusia County service areas including Ormond Beach, Daytona Beach, Port Orange, New Smyrna Beach, and Edgewater. Contact us to confirm availability for your address.",
  },
  {
    q: 'How do I get a free design consultation from Dippel\'s Outdoor Services?',
    a: "Simply call (386) 301-4399 or (386) 566-8781, email dippelsoutdoor@gmail.com, or use our online consultation request form. We'll schedule an on-site visit, assess your project, and provide a detailed, transparent quote — completely free with no obligation.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-28 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3 justify-center">
            <span className="h-px w-8 bg-gold inline-block"></span>
            Common Questions
          </p>
          <h2 className="font-serif text-charcoal font-bold mb-4" style={{ fontSize: 'clamp(32px, 3.2vw, 48px)' }}>
            Everything You Need to Know
          </h2>
          <p className="text-charcoal-muted text-base max-w-xl mx-auto">
            Questions about outdoor services in Palm Coast, Ormond Beach, and across Florida&apos;s east coast — answered plainly.
          </p>
        </div>

        {/* FAQs */}
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                open === i
                  ? 'border-forest/30 bg-forest/3'
                  : 'border-stone-dark bg-stone/50 hover:border-charcoal/20'
              }`}
            >
              <button
                className="w-full flex items-start justify-between gap-5 px-7 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                <span className={`font-semibold text-[14px] leading-relaxed transition-colors ${
                  open === i ? 'text-forest' : 'text-charcoal'
                }`}>
                  {faq.q}
                </span>
                <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-colors mt-0.5 ${
                  open === i ? 'bg-forest text-white' : 'bg-stone-dark text-charcoal'
                }`}>
                  <i className={`text-sm transition-transform duration-200 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>

              {open === i && (
                <div className="px-7 pb-6">
                  <div className="h-px bg-forest/10 mb-4"></div>
                  <p className="text-charcoal-muted text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 text-center">
          <p className="text-charcoal-muted text-sm">
            Still have questions?{' '}
            <a href="tel:3863014399" className="text-forest font-semibold hover:underline whitespace-nowrap">
              Call (386) 301-4399
            </a>{' '}
            or{' '}
            <a href="mailto:dippelsoutdoor@gmail.com" className="text-forest font-semibold hover:underline">
              email us
            </a>.
          </p>
        </div>
      </div>
    </section>
  );
}
